// src/components/LanguageWrapper.jsx
import { useParams, Outlet, Navigate, useLocation } from "react-router-dom";
import i18n from "../i18n";
import { useEffect } from "react";
import NavBar from "./NavBar";
const supportedLangs = ["it", "en", "fr", "de", "es"];

export default function LanguageWrapper() {
  const { lang } = useParams();
  const location = useLocation();

  useEffect(() => {
    if (supportedLangs.includes(lang) && i18n.language !== lang) {
      
      i18n.changeLanguage(lang);
      document.documentElement.lang = lang;
    }
  }, [lang]);

  if (!supportedLangs.includes(lang)) {
    return <Navigate to="/it" replace />;
  }

    const hideNavBarRoutes = ["/etichetta-alimentare/2025/germoglio","/etichetta-alimentare/2025/il-biunt"];
  const shouldHideNavBar = hideNavBarRoutes.includes(location.pathname);

  return ( <>
        {!shouldHideNavBar && <NavBar />}
      <Outlet />
    </>);
}
